import React, { useContext, useEffect, useState } from "react";
import Footer from "../../components/footer/Footer";
import "bootstrap/dist/css/bootstrap.min.css";
import { addToList, showListing } from "../../features/listingSlice";
import NavbarComponent from "../../components/navbar/NavbarComponent";
import "./DetailPage.css";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { PathContext } from "../../App";
import { toast } from "react-toastify";
import Meta from "../../components/Meta";
import { titleCase } from "title-case";
const GOOGLE_API_KEY = "AIzaSyBnS_3SaUCRTUCbVTt-pdDy26RbASWxE1g";

function DetailPage() {
  const [description, setDescription] = useState(
    "This 3-bed with a loft, 2-bath home in the gated community of The Hideout has it all. From the open floor plan to the abundance of light from the windows, this home is perfect for entertaining. The living room and dining room have vaulted ceilings and a beautiful fireplace. You will love spending time on the deck taking in the beautiful views. In the kitchen, you'll find stainless steel appliances and a tile backsplash, as well as a breakfast bar."
  );
  const maxLength = 450;
  const [isExpanded, setIsExpanded] = useState(false);
  const toggleText = () => {
    setIsExpanded(!isExpanded);
  };
  const formatPrice = (price) => {
    return parseInt(price).toLocaleString("en-US");
  };
  const navigate = useNavigate();
  const { path, setPath } = useContext(PathContext);
  const location = useLocation();
  const { data } = location.state || {};

  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize();

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleSchedule = async () => {
    try {
      const baseUrl = "https://maps.googleapis.com/maps/api/geocode/json";
      const params = new URLSearchParams({
        address: data?.address,
        key: GOOGLE_API_KEY,
      });

      const response = await fetch(`${baseUrl}?${params}`);
      const result = await response.json();

      if (result.status === "OK") {
        const addressComponents = result.results[0].address_components;

        let state = null;
        let postalCode = null;

        addressComponents.forEach((component) => {
          if (component.types.includes("administrative_area_level_1")) {
            state = component.short_name;
          }
          if (component.types.includes("postal_code")) {
            postalCode = component.long_name;
          }
        });

        if (state === "CA") {
          localStorage.setItem("houseAddress", data?.address);
          localStorage.setItem("houseZipCode", data?.zipcode);
          localStorage.setItem("houseImages", JSON.stringify(data?.images));
          setPath("tour");
          navigate("/schedule-tour");
        } else {
          toast.error("Coming Soon");
        }
        return postalCode;
      } else {
        return null;
      }
    } catch (error) {
      console.error("Error fetching zipcode:", error);
      return null;
    }
  };
  const handleOffer = async () => {
    try {
      const baseUrl = "https://maps.googleapis.com/maps/api/geocode/json";
      const params = new URLSearchParams({
        address: data?.address,
        key: GOOGLE_API_KEY,
      });

      const response = await fetch(`${baseUrl}?${params}`);
      const result = await response.json();

      if (result.status === "OK") {
        const addressComponents = result.results[0].address_components;

        let state = null;
        let postalCode = null;

        addressComponents.forEach((component) => {
          if (component.types.includes("administrative_area_level_1")) {
            state = component.short_name;
          }
          if (component.types.includes("postal_code")) {
            postalCode = component.long_name;
          }
        });

        if (state === "CA") {
          localStorage.setItem("houseAddress", data?.address);
          localStorage.setItem("houseZipCode", data?.zipcode);
          localStorage.setItem("houseImages", JSON.stringify(data?.images));
          setPath("offer");
          navigate("/make-offer");
        } else {
          toast.error("Coming Soon");
        }
        return postalCode;
      } else {
        return null;
      }
    } catch (error) {
      console.error("Error fetching zipcode:", error);
      return null;
    }
  };
  return (
    <>
      <Meta
        title={`${titleCase(data?.address)} | DDH`}
        description={`For sale: ${data?.price}. ${data?.beds} bed, ${data?.baths} bath, ${data?.sq_ft} sqft home at ${titleCase(data?.address)}. View property details, photos, and neighborhood info.`}
      />
      <div className="detail-section">
        <NavbarComponent />

        <div
          className="container-fluid px-0"
          style={{ paddingBottom: "120px" }}
        >
          <div className="row px-0 mx-0 detail-page-add">
            <div className="col-12 px-0 mx-0">
              <img
                src="/img/detail-page-add.svg"
                className="img-fluid detail-page-add-image"
                alt=""
                onClick={()=>{navigate("/advertiser-register")}}
                style={{cursor: "pointer"}}
              />
            </div>
          </div>
          <div className="row px-0 mx-0 detail-page-content">
            <div className="col-md-6 px-0 mx-0">
              <h2 className="detail-page-heading">{data?.address}</h2>
              {/* <table className="detail-page-description" border="0">
                <tr>
                  <td className="pe-2">Los Angeles City, CA, USA</td>
                  <td
                    className="ps-2"
                    style={{ borderLeft: "1px solid #e1e1e1" }}
                  >
                    1 Month Ago
                  </td>
                </tr>
              </table> */}
              <div className="detail-page-description-2">
                <div className="d-flex align-items-center gap-2">
                  <img src="/img/detail-bed.svg" className="img-fluid" alt="" />{" "}
                  {data?.beds || "-"} Bed
                </div>
                <div className="d-flex align-items-center gap-2">
                  <img
                    src="/img/detail-bath.svg"
                    className="img-fluid"
                    alt=""
                  />{" "}
                  {data?.baths || "-"} Bath
                </div>
                <div className="d-flex align-items-center gap-2">
                  <img
                    src="/img/detail-sq-ft.svg"
                    className="img-fluid"
                    alt=""
                  />{" "}
                  {data?.sq_ft || "-"} Sqft
                </div>
              </div>
            </div>
            <div
              className={`col-md-6 px-0 mx-0 text-end ${isMobile ? "mt-3" : ""}`}
            >
              {/* <h2 className="detail-page-heading"> $ {formatPrice(data?.price)}</h2> */}
              <h2 className="detail-page-heading"> {data?.price}</h2>
            </div>
          </div>

          {isMobile ? (
            <>
              <div className="row px-0 mx-0 detail-page-grid">
                {data?.images?.length > 0
                  ? data.images.map((img, index) => (
                      <div key={index} className="col-lg-6 px-0 py-2 mx-0">
                        <img
                          src={img || "/img/user-register-image.svg"}
                          className="img-fluid mobile-detail-image"
                          alt=""
                        />
                      </div>
                    ))
                  : null}
              </div>
            </>
          ) : (
            <>
              <div className="row px-0 mx-0 detail-page-grid">
                {data?.images?.length > 2 ? (
                  <div className="col-lg-6 ps-0 pe-2  mx-0 detail-page-grid-left">
                    <img
                      src={data?.images[0] || "/img/user-register-image.svg"}
                      className="img-fluid detail-left-image"
                      alt=""
                    />
                  </div>
                ) : (
                  <div className="col-lg-12 ps-0 pe-2 mx-0 detail-page-grid-left">
                    <img
                      src={data?.images[0] || "/img/user-register-image.svg"}
                      className="img-fluid detail-left-image"
                      alt=""
                    />
                  </div>
                )}

                {data?.images?.length >= 3 && (
                  <div className="col-lg-6 pe-0 mx-0 ps-3 detail-page-grid-right">
                    <div className="container-fluid px-0 mx-0">
                      <div className="row">
                        {data?.images?.length >= 3 && (
                          <>
                            <div className="col-lg-6 p0-0 ps-1  mx-0 detail-page-grid-right-1">
                              <img
                                src={
                                  data?.images[1] ||
                                  "/img/user-register-image.svg"
                                }
                                className="img-fluid detail-image-right"
                                alt=""
                              />
                            </div>
                            <div className="col-lg-6 p0-0 ps-1  mx- detail-page-grid-right-1">
                              <img
                                src={
                                  data?.images[2] ||
                                  "/img/user-register-image.svg"
                                }
                                className="img-fluid detail-image-right-top"
                                alt=""
                              />
                            </div>
                          </>
                        )}
                      </div>

                      <div className="row ">
                        <div className="col-lg-6 p0-0 ps-1  mx-0 detail-page-grid-right-1-2">
                          <img
                            src={
                              data?.images[3] || "/img/user-register-image.svg"
                            }
                            className="img-fluid detail-image-right"
                            alt=""
                          />
                        </div>
                        <div className="col-lg-6 p0-0 ps-1  mx- detail-page-grid-right-1-2">
                          <img
                            src={
                              data?.images[4] || "/img/user-register-image.svg"
                            }
                            className="img-fluid detail-image-right-buttom"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </>
          )}
          <div className="row px-0 mx-0 mt-4">
            <div className={`col-lg-6 px-0 mx-0 ${isMobile ? "" : "pe-2"}`}>
              <button onClick={handleSchedule} className="btn detail-page-btn">
                <img src="/img/detail-shedule-tour.svg" alt="" />
                Schedule a Tour
              </button>
            </div>
            <div className={`col-lg-6 px-0 mx-0 ${isMobile ? "mt-2" : "ps-2"}`}>
              <button onClick={handleOffer} className="btn detail-page-btn">
                <img src="/img/detail-make-offer.svg" alt="" />
                Make an Offer
              </button>
            </div>
          </div>
          <div className="row px-0 mx-0 detail-address-description">
            <div className={`col-lg-8 ps-0 ${isMobile ? "px-0" : "pe-3"}`}>
              <div className="detail-address-description-1">
                <h2 className="detail-address-description-heading">
                  Property Description
                </h2>
                <p className="detail-address-description-paragraph">
                  {isExpanded
                    ? data?.description
                    : `${data?.description.slice(0, maxLength)}${data?.description.length > maxLength ? "..." : ""}`}
                </p>
                {data?.description.length > maxLength && (
                  <button onClick={toggleText} className="show-more-button">
                    {isExpanded ? "Show Less" : "Show More"}
                  </button>
                )}
                <div className="row list-group-detail w-100 mt-4">
                  {data?.key_details_values?.map((item, index) => (
                    <>
                      <div
                        className={`col-md-4 list-group-item-detail d-flex align-items-center gap-2`}
                      >
                        <img
                          src="/img/check_circle.svg"
                          className="img-fluid"
                          style={{ height: "24px" }}
                          alt=""
                        />
                        {item}
                      </div>
                    </>
                  ))}
                </div>
              </div>
            </div>
            <div
              className={`col-lg-4 detail-address-image pe-0 ${isMobile ? "px-0" : "ps-2"}`}
            >
              <img
                src="/img/Advertisement-for-a-house.svg"
                className="img-fluid detail-address-image-image"
                alt=""
                onClick={()=>{navigate("/advertiser-register")}}
                style={{cursor: "pointer"}}
              />
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}

export default DetailPage;
